import { defineMessages } from '@jutro/locale';

export default defineMessages({
    filterByLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Filter by',
        defaultMessage: 'Filter by'
    },
    clearFilters: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Clear filters',
        defaultMessage: 'Clear filters'
    },
    dateRangeLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Date Range',
        defaultMessage: 'Date Range'
    },
    dateFromLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.From',
        defaultMessage: 'From'
    },
    dateToLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.To',
        defaultMessage: 'To'
    },
    productLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Product',
        defaultMessage: 'Product'
    },
    allProducts: {
        id: 'ml.gateway.MLJobResultsFilterComponent.All Products',
        defaultMessage: 'All Products'
    },
    groupLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Group',
        defaultMessage: 'Group'
    },
    changeGroupLink: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Change Group',
        defaultMessage: 'Change Group'
    },
    producerCodeLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Producer Code',
        defaultMessage: 'Producer Code'
    },
    allProducerCode: {
        id: 'ml.gateway.MLJobResultsFilterComponent.All Producer Codes',
        defaultMessage: 'All Producer Codes'
    },
    filterButtonLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.FILTER',
        defaultMessage: 'FILTER'
    },
    multipleRecordsAvailableAlert: {
        id: 'ml.gateway.MLJobResultsFilterComponent.multipleRecordsAvailableAlert',
        defaultMessage: '{multipleRecordsAreAvailable}  The first {numRows} have been displayed.  To refine your list, please use the filter options.'
    },
    multipleRecordsAreAvailable: {
        id: 'ml.gateway.MLJobResultsFilterComponent.multipleRecordsAreAvailable',
        defaultMessage: 'Multiple records are available.'
    }
});
